import React, { useMemo, useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
const Reserved = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  
const user = JSON.parse(localStorage.getItem("authUser"));

  const [modal, setModal] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const [add, setAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [currentQun, setCurrentQun] = useState(null);
  const [currentStock, setCurrentStock] = useState(null);
  const [inventoryItems, setinventoryItems] = useState([]);
  const toggleModal = () => setModal(!modal);
  const toggleTransferModal = () => setTransfer(!transfer);
  const toggleAddModal = () => setAdd(!add);
  const [error, setError] = useState(null);
   const fetchproductsData = async () => {
            try {
              setError(null);
              const response = await fetch(`${baseurl}/admin/products/products`);
              if (!response.ok) throw new Error("Network response was not ok");
              const data = await response.json();
              setinventoryItems(data);
            } catch (error) {
              setError(error.message);
            }
          };
        
          useEffect(() => {
            fetchproductsData();
          }, []);
  

  // For edit reserved product model
  const handleEditClick = (product) => {
    setCurrentProduct(product);
    toggleModal();
  };

  // For transfer reserved quantity model
  const handleTransferClick = (product) => {
    setCurrentProduct(product);
    toggleTransferModal();
    setCurrentQun(null);
  };

  // For add stock reserved quantity model
  const handleAddClick = (product) => {
    console.log("product", product);
    setCurrentStock(product);
    toggleAddModal();
  };

  // For add new reserved product model
  const handleAddReservedProduct = () => {
    setCurrentProduct(null);
    setIsEdit(false);
    toggleModal();
  };

  // For add/edit reserved product model validation
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (currentProduct && currentProduct.id) || "",
      productName: (currentProduct && currentProduct.productName) || "",
      quantity: (currentProduct && currentProduct.quantity) || "",
      price: (currentProduct && currentProduct.price) || "",
    },
    validationSchema: Yup.object({
      productName: Yup.string().required("Please enter the Product name"),
      quantity: Yup.string().required("Please add quantity"),
      price: Yup.string().required("Please add price"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        console.log("Updating Reserved Product:", values);
      } else {
        console.log("Adding new Reserved Product:", values);
      }
      toggleModal();
    },
  });

  const transferValidationSchema = Yup.object({
    currentQun: Yup.number()
      .required("Please enter a transfer quantity")
      .min(1, "Quantity must be at least 1")
      .max(
        currentProduct?.total_stock || 0,
        "Cannot transfer more than available quantity"
      ),
  });
const now = () => {
  const date = new Date();
  return date.toISOString().split('T')[0]; // "YYYY-MM-DD"
};
  // For transfer reserved product model validation
  const transferFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (currentProduct && currentProduct.id) || "",
      quantity: (currentProduct && currentProduct.reserved_quantity) || "0",
      totalStock: (currentProduct && currentProduct.total_stock) || "0",
      currentQun: (currentQun && currentQun) || "",
    },
    validationSchema: transferValidationSchema,
    onSubmit: async (values) =>  {
      const { currentQun,purchasePrice,selectedDate,id } = values;
        
            try {
              let response;
              
                // For add, make an API POST request
                response = await fetch(baseurl+'/admin/products/transfers', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    quantity: currentQun, 
                    purchase_price: 0, 
                    cdate: now(),
                    stock_type:'transfer',
                    product_id : id,
                    userid:user.id
                  }),
                });
               if (!response.ok) {
                  throw new Error("Error adding new user");
                }

                toast.success('Product Stock transfer successfully!', 'success');
                fetchproductsData();
              toggleTransferModal();
            } catch (error) {
              console.error(error);
              // Handle any errors, show an error message if needed
            }
      
    },
  });

  // For add stock product model validation
  const stockFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (currentStock && currentStock.id) || "",
      productName: (currentStock && currentStock.product_name) || "",
      quantity: (currentStock && currentStock.reserved_quantity) || "0",
      totalStock: (currentStock && currentStock.total_stock) || "0",
      storeName: "",
      poNo: "",
      supplierName: "",
      inwardInvoiceNo: "",
      invoiceDate: "",
      addQuantity: "",
      purchasePrice: "",
      selectedDate: "",
    },
    validationSchema: Yup.object({
      addQuantity: Yup.number()
        .required("Please enter a quantity")
        .min(1, "Quantity must be at least 1"),
      purchasePrice: Yup.number()
        .required("Please enter a purchase price")
        .min(0.01, "Price must be at least 0.01"),
      selectedDate: Yup.date().required("Please select a date").nullable(),
      storeName: Yup.string()
    .required("Store name is required"),

  poNo: Yup.string()
    .required("PO Ref is required"),

  supplierName: Yup.string()
    .required("Supplier name is required"),

  inwardInvoiceNo: Yup.string()
    .required("Invoice number is required"),

  invoiceDate: Yup.date()
    .required("Invoice date is required"),
    }),
    onSubmit: async (values) => {
      const { addQuantity,purchasePrice,selectedDate,storeName,poNo,supplierName,inwardInvoiceNo,invoiceDate,id } = values;
        
            try {
              let response;
              
                // For add, make an API POST request
                response = await fetch(baseurl+'/admin/products/stocks', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    quantity: addQuantity, 
                    purchase_price: purchasePrice, 
                    cdate: selectedDate,
                    stock_type:'add',
                    storename:storeName,
                    pono:poNo,
                    supplier_name:supplierName,
                    inward_invoice_no:inwardInvoiceNo,
                    invoice_date:invoiceDate,
                    product_id : id,
                    userid:user.id
                  }),
                });
               if (!response.ok) {
                  throw new Error("Error adding new user");
                }

                toast.success('Product Stock added successfully!', 'success');
                
              // Close modal or do further actions
              //toggleModal();
              toggleAddModal();
              fetchproductsData();
            } catch (error) {
              console.error(error);
              // Handle any errors, show an error message if needed
            }
      
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Online Store Qty",
        accessor: "reserved_quantity",
        filterable: true,
        Cell: ({ row }) => {
          const value = row.original.reserved_quantity;
          const minStockWarning = row.original.min_stock_warning;

          if (value === 0) {
            return <div className="text-danger fw-bold">Out of Stock</div>;
          } else if (value < minStockWarning) {
            return <div className="text-danger fw-bold">{value}</div>;
          } else {
            return <div>{value}</div>;
          }
        },
      },{
        Header: "Offline Store Qty",
        accessor: "total_stock",
        filterable: true,
        Cell: ({ row }) => {
          const value = row.original.total_stock;
          const minStockWarning = row.original.min_stock_warning;

          if (value === 0) {
            return <div className="text-danger fw-bold">Out of Stock</div>;
          } else if (value < minStockWarning) {
            return <div className="text-danger fw-bold">{value}</div>;
          } else {
            return <div>{value}</div>;
          }
        },
      },
      {
        Header: "Purchase Price (Per item)",
        accessor: "purchase_price",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">₹ {value}</div>,
      },
      {
        Header: "Transfer",
        Cell: ({ row }) => {
          return (
            <Button
              type="button"
              color="success"
              className="btn mb-2 me-2"
              //style={{ width: "200px" }}
              onClick={() => handleTransferClick(row.original)}
            >
              <i className="bx bx-transfer me-1"></i>
              
            </Button>
          );
        },
      },
      {
        Header: "Add Stock",
        Cell: ({ row }) => {
          return (
            <Button
              type="button"
              color="success"
              className="btn mb-2 me-2"
              //style={{ width: "150px" }}
              onClick={() => handleAddClick(row.original)}
            >
              <i className="mdi mdi-plus me-1" />
              
            </Button>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to={`/manage-inventory/reserved/view-details/${row.original.id}`}
                className="text-success"
                target="_blank"
              >
                <i
                  className="mdi mdi-eye-outline font-size-18"
                  id="viewtooltip"
                ></i>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              {/* <Link
                to="#"
                className="text-success"
                onClick={() => handleEditClick(row.original)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link> */}
            </div>
          );
        },
      },
    ],
    []
  );

  document.title = "Manage inventory - Reserved | Vekart"

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Manage Inventory" breadcrumbItem="Reserved" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={inventoryItems}
                    isGlobalFilter={true}
                    customPageSize={10}
                    //isAddReservedProduct={true}
                    //handleAddReservedProduct={handleAddReservedProduct}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal for Add/Edit Reserved Products */}
          <Modal
            isOpen={modal}
            toggle={toggleModal}
            backdrop="static"
            keyboard={false}
          >
            <ModalHeader toggle={toggleModal} tag="h4">
              {isEdit ? "Edit Product" : "Add Product"}
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Product Name</Label>
                      <Input
                        name="productName"
                        type="text"
                        placeholder="Insert Product Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.productName || ""}
                        invalid={
                          formik.touched.productName &&
                          formik.errors.productName
                            ? true
                            : false
                        }
                      />
                      {formik.touched.productName &&
                      formik.errors.productName ? (
                        <FormFeedback type="invalid">
                          {formik.errors.productName}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Product Quantity</Label>
                      <Input
                        name="quantity"
                        type="number"
                        placeholder="Insert Product Quantity"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.quantity || ""}
                        invalid={
                          formik.touched.quantity && formik.errors.quantity
                            ? true
                            : false
                        }
                      />
                      {formik.touched.quantity && formik.errors.quantity ? (
                        <FormFeedback type="invalid">
                          {formik.errors.quantity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Product Price</Label>
                      <Input
                        name="price"
                        type="number"
                        placeholder="Insert Product Price"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.price || ""}
                        invalid={
                          formik.touched.price && formik.errors.price
                            ? true
                            : false
                        }
                      />
                      {formik.touched.price && formik.errors.price ? (
                        <FormFeedback type="invalid">
                          {formik.errors.price}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        {isEdit ? "Update" : "Save"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          {/* Modal for Transfer Reserved Products */}
          <Modal
            isOpen={transfer}
            toggle={toggleTransferModal}
            backdrop="static"
            keyboard={false}
          >
            <ModalHeader toggle={toggleTransferModal} tag="h4">
              Transfer to Online Store Quantity
            </ModalHeader>
            <ModalBody>
              <form onSubmit={transferFormik.handleSubmit}>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Online Store Quantity</Label>
                      <Input type="text"
                      name="quantity"
                      onChange={transferFormik.handleChange}
                        onBlur={transferFormik.handleBlur}
                        value={transferFormik.values.quantity || ""}
                        invalid={
                          transferFormik.touched.quantity && transferFormik.errors.quantity
                            ? true
                            : false }
                         disabled />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Offline Store Quantity</Label>
                      <Input type="number" onChange={transferFormik.handleChange}
                        name="totalStock"
                        onBlur={transferFormik.handleBlur}
                        value={transferFormik.values.totalStock || ""}
                        invalid={
                          transferFormik.touched.totalStock && transferFormik.errors.totalStock
                            ? true
                            : false } disabled />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Transfer to Online Store Quantity</Label>
                      <Input
                        name="currentQun"
                        type="number"
                        placeholder="Insert Transfer Quantity"
                        onChange={transferFormik.handleChange}
                        onBlur={transferFormik.handleBlur}
                        value={transferFormik.values.currentQun || ""}
                        invalid={
                          transferFormik.touched.currentQun &&
                          transferFormik.errors.currentQun
                            ? true
                            : false
                        }
                      />
                      {transferFormik.touched.currentQun &&
                      transferFormik.errors.currentQun ? (
                        <FormFeedback type="invalid">
                          {transferFormik.errors.currentQun}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        Transfer
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          {/* Modal for Add Stock quantity */}
          <Modal
            isOpen={add}
            toggle={toggleAddModal}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <ModalHeader toggle={toggleAddModal} tag="h4">
              Add Stock
            </ModalHeader>
            <ModalBody>
              <form onSubmit={stockFormik.handleSubmit}>
                <Row>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Product Name</Label>
                      <Input
                        type="text"
                        value={stockFormik?.values?.productName}
                        disabled
                      />
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">
                        Offline Store Quantity
                      </Label>
                      <Input type="number" value={stockFormik?.values?.totalStock} disabled />
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">
                        Online Store Quantity
                      </Label>
                      <Input
                        type="number"
                        name="quantity"
                        value={stockFormik?.values?.quantity}
                        disabled
                      />
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Add Quantity</Label>
                      <Input
                        name="addQuantity"
                        type="number"
                        placeholder="Insert Quantity"
                        onChange={stockFormik.handleChange}
                        onBlur={stockFormik.handleBlur}
                        value={stockFormik.values.addQuantity || ""}
                        invalid={
                          stockFormik.touched.addQuantity &&
                          stockFormik.errors.addQuantity
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.addQuantity &&
                      stockFormik.errors.addQuantity ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.addQuantity}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Purchase Price</Label>
                      <Input
                        name="purchasePrice"
                        type="number"
                        placeholder="Insert Purchase Price"
                        onChange={stockFormik.handleChange}
                        onBlur={stockFormik.handleBlur}
                        value={stockFormik.values.purchasePrice || ""}
                        invalid={
                          stockFormik.touched.purchasePrice &&
                          stockFormik.errors.purchasePrice
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.purchasePrice &&
                      stockFormik.errors.purchasePrice ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.purchasePrice}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Select Date</Label>
                      <Input
                        name="selectedDate"
                        type="date"
                        onChange={stockFormik.handleChange}
                        onBlur={stockFormik.handleBlur}
                        value={stockFormik.values.selectedDate || ""}
                        invalid={
                          stockFormik.touched.selectedDate &&
                          stockFormik.errors.selectedDate
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.selectedDate &&
                      stockFormik.errors.selectedDate ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.selectedDate}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  
                  <Col className="col-4">
  <div className="mb-3">
    <Label className="form-label">Select Store Name</Label>
    <Input
      type="select"
      name="storeName"
      onChange={stockFormik.handleChange}
      onBlur={stockFormik.handleBlur}
      value={stockFormik.values.storeName}
      invalid={
        stockFormik.touched.storeName &&
        stockFormik.errors.storeName
          ? true
          : false
      }
    >
      <option value="">Select Store</option>
      <option value="Baroda Warehouse">Baroda Warehouse</option>
    </Input>

    {stockFormik.touched.storeName &&
    stockFormik.errors.storeName ? (
      <FormFeedback type="invalid">
        {stockFormik.errors.storeName}
      </FormFeedback>
    ) : null}
  </div>
</Col>

                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">VE PO Ref.</Label>
                      <Input
                        name="poNo"
                        type="text"
                        placeholder="Enter PO Ref"
                        onChange={stockFormik.handleChange}
                        onBlur={stockFormik.handleBlur}
                        value={stockFormik.values.poNo || ""}
                        invalid={
                          stockFormik.touched.poNo &&
                          stockFormik.errors.poNo
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.poNo &&
                      stockFormik.errors.poNo ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.poNo}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Supplier Name </Label>
                      <Input
                        name="supplierName"
                        type="text"
                        placeholder="Enter Supplier Name"
                        onChange={stockFormik.handleChange}
                        onBlur={stockFormik.handleBlur}
                        value={stockFormik.values.supplierName || ""}
                        invalid={
                          stockFormik.touched.supplierName &&
                          stockFormik.errors.supplierName
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.supplierName &&
                      stockFormik.errors.supplierName ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.supplierName}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Inward Invoice No.</Label>
                      <Input
                         name="inwardInvoiceNo"
                         type="text"
                         placeholder="Enter Invoice No"
                         onChange={stockFormik.handleChange}
                         onBlur={stockFormik.handleBlur}
                         value={stockFormik.values.inwardInvoiceNo || ""}
                        
                        invalid={
                          stockFormik.touched.inwardInvoiceNo &&
                          stockFormik.errors.inwardInvoiceNo
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.inwardInvoiceNo &&
                      stockFormik.errors.inwardInvoiceNo ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.inwardInvoiceNo}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col className="col-4">
                    <div className="mb-3">
                      <Label className="form-label">Invoice Date</Label>
                      <Input
                        name="invoiceDate"
                        type="date"
                        onChange={stockFormik.handleChange}
                        onBlur={stockFormik.handleBlur}
                        value={stockFormik.values.invoiceDate || ""}
                        invalid={
                          stockFormik.touched.invoiceDate &&
                          stockFormik.errors.invoiceDate
                            ? true
                            : false
                        }
                      />
                      {stockFormik.touched.invoiceDate &&
                      stockFormik.errors.invoiceDate ? (
                        <FormFeedback type="invalid">
                          {stockFormik.errors.invoiceDate}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default withRouter(Reserved);
